const tickerColumns = [
  {
    key: "num",
    label: "SN.",
  },
  {
    key: "name",
    label: "Tick",
  },

  {
    key: "arbiName",
    label: "Arbi Translation",
  },

  {
    key: "actions",
    label: "Actions",
  },
];

export { tickerColumns };
